import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { var_api } from '../../../constant';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UomMaster = () => {
  const tableHeaders = ["#", "UOM ", "Description", "Status", "Action"];
  const [uomData, setUomData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [userType, setUserType] = useState("");
  const [formData, setFormData] = useState({
    id: null,
    uom_name: '',
    description: '',
    active_status: 1
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [pendingStatus, setPendingStatus] = useState('');
  const [statusMessage, setStatusMessage] = useState("");
  const [initialLoading, setInitialLoading] = useState(true);
const [errors, setErrors] = useState({});
const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   fetchUomData();
  //   const type = localStorage.getItem("user_type") || "";
  //   setUserType(type);
  // }, []);
  useEffect(() => {
    const loadInitialData = async () => {
      try {
        setInitialLoading(true);
        await fetchUomData();
      } catch (error) {
        toast.error("Failed to load data", { autoClose: 3000 });
      } finally {
        setInitialLoading(false);
      }
    };
  
    loadInitialData();
    const type = localStorage.getItem("user_type") || "";
    setUserType(type);
  }, []);

  const fetchUomData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_uom_master/get`);
      setUomData(res.data || []);
    } catch (err) {
      console.error("Failed to fetch UOM data", err);
    }
  };

  const handleInputChange = (e) => {
  const { name, value } = e.target;

  setFormData(prev => ({
    ...prev,
    [name]: value,
  }));

  // Clear the error for the current field
  setErrors(prev => ({
    ...prev,
    [name]: '',  // remove error message when user types
  }));
};

  const handleAddClick = () => {
    setFormData({
      id: null,
      uom_name: '',
      description: '',
      active_status: 1
    });
    setIsEditMode(false);
    setShowModal(true);
        setErrors({});

  };

  const handleEditClick = (item) => {
    // const statusValue = item.active_status === 1 ? 'Active' : 'Inactive';
    setFormData({ ...item });
    setIsEditMode(true);
    setShowModal(true);
     setErrors({});

  };

  const handleStatusChange = () => {
    const newStatus = formData.active_status === 'Active' ? 'Inactive' : 'Active';
    setPendingStatus(newStatus);
    setPasswordInput("");
    setStatusMessage("");
    setShowModal(false);
    setIsEditMode(false);
    setShowPasswordModal(true);
  };

  const confirmStatusChange = async () => {
    if (!passwordInput.trim()) {
      setStatusMessage("Incorrect password");
      return;
    }

    try {
      const updatedForm = {
        uom_name: formData.uom_name,
        description: formData.description,
        active_status: pendingStatus === 'Active' ? 1 : 0
      };
      await axios.put(`${var_api}sa_uom_master/update/${formData.id}`, updatedForm);
      toast.success("Status updated successfully!", { position: "top-right", autoClose: 4000 });
      setFormData(prev => ({ ...prev, active_status: pendingStatus }));
      setShowPasswordModal(false);
      setPasswordInput("");
      fetchUomData();
    } catch (err) {
      console.error("Error updating status", err);
      toast.error("Failed to update status.", { position: "top-right", autoClose: 4000 });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const newErrors = {};
    if (!formData.uom_name.trim()) newErrors.uom_name = "UOM is required";
    setErrors(newErrors);
  
    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields", { autoClose: 3000 });
      return;
    }
  
    try {
      setLoading(true);
  
      // const statusToSend = userType === "1" ? 1 : (formData.active_status === 'Active' ? 1 : 0);
      const data = {
        uom_name: formData.uom_name,
        description: formData.description,
        active_status: formData.active_status
      };
  
      if (isEditMode && formData.id) {
        await axios.put(`${var_api}sa_uom_master/update/${formData.id}`, data);
        toast.success("UOM updated successfully!", { autoClose: 3000 });
      } else {
        await axios.post(`${var_api}sa_uom_master/post`, data);
        toast.success("UOM created successfully!", { autoClose: 3000 });
      }
  
      setShowModal(false);
      setFormData({ id: null, uom_name: '', description: '', active_status: '' });
      fetchUomData();
    } catch (err) {
      if (err.response?.data?.message?.includes("already exists")) {
        toast.warning("UOM already exists!", { autoClose: 3000 });
      } else {
        toast.error("Error saving UOM. Please try again.", { autoClose: 3000 });
      }
    } finally {
      setLoading(false);
    }
  };
  

  const filteredData = uomData.filter(item =>
    Object.values(item).some(val => String(val).toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
    <Card>
      <Card.Body>
      {initialLoading ? (
    <div className="text-center my-5">
      <div className="spinner-border text-primary" role="status"></div>
      <div>Loading data...</div>
    </div>
  ) : (
    <>
        <div className="d-flex justify-content-end mb-3 gap-2">
          <input
            type="text"
            className="form-control w-auto"
            placeholder="Search UOM..."
            value={searchQuery}
            onChange={e => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
          />
          <Button variant="secondary" onClick={handleAddClick}>Add</Button>
        </div>

        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>{tableHeaders.map((header, idx) => (<th key={idx}>{header}</th>))}</tr>
            </thead>
            <tbody>
            {paginatedData.length === 0 ? (
        <tr>
          <td colSpan="8" className="text-center text-muted py-3">
            No data found
          </td>
        </tr>
      ) : (
            paginatedData.map((item, idx) => (
                <tr key={item.id}>
                  <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                  <td>{item.uom_name}</td>
                  <td>{item.description}</td>
                  <td>
                    <span className={`badge ${item.active_status === 1 || item.active_status === 'Active' ? 'bg-success' : 'bg-danger'}`}>
                      {item.active_status === 1 || item.active_status === 'Active' ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td >
                    <Link to="#" className="btn shadow btn-xs sharp me-1" style={{ backgroundColor: "#007bff", color: "white" }} onClick={() => handleEditClick(item)}>
                      <i className="fas fa-pencil-alt"></i>
                    </Link>
                  </td>
                </tr>
              )))}
            </tbody>
          </table>

          <div className="d-flex justify-content-end mt-3">
            {[...Array(totalPages)].map((_, idx) => (
              <Button
                key={idx}
                variant={currentPage === idx + 1 ? "primary" : "light"}
                onClick={() => setCurrentPage(idx + 1)}
                className="me-1"
              >
                {idx + 1}
              </Button>
            ))}
          </div>
        </div>
        </>
  )}
      </Card.Body>

      {/* Form Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{isEditMode ? "Edit UOM" : "Add UOM"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
  <Form.Label>UOM  <span className="text-danger">*</span></Form.Label>
  <Form.Control
    type="text"
    name="uom_name"
    value={formData.uom_name}
    placeholder="Enter name"
    onChange={handleInputChange}
  />
  {errors.uom_name && <div className="text-danger small mt-1">{errors.uom_name}</div>}
</Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control type="text" name="description" value={formData.description} placeholder="Enter description" onChange={handleInputChange} />
            </Form.Group>

            {isEditMode && (
              // <Form.Group className="mb-3">
              //   <Form.Label>Status</Form.Label>
              //   <div className="d-flex align-items-center gap-3">
              //     <Form.Check
              //       type="switch"
              //       id="status-switch"
              //       checked={formData.active_status === 'Active'}
              //       onChange={handleStatusChange}
              //       className={formData.active_status === 'Active' ? 'custom-switch-green' : 'custom-switch-red'}
              //     />
              //     <span>{formData.active_status}</span>
              //   </div>
              // </Form.Group>
              <Form.Group className="mb-2 d-flex align-items-center gap-2">
              <Form.Label className="mb-0">
                {formData.active_status === 1 ? "Active" : "Inactive"}
              </Form.Label>
              <Form.Check
                type="switch"
                id="active-status-switch"
                checked={formData.active_status === 1}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    active_status: e.target.checked ? 1 : 0,
                  })
                }
                className={formData.active_status === 1 ? "custom-switch-green" : ""}
              />
            </Form.Group>
            )}

            <div className="d-flex justify-content-end gap-2">
              {!isEditMode ? (
                <>
                <Button variant="secondary" type="submit" disabled={loading}>
                  {loading ? 'Creating...' : 'Create'}
                </Button>
                  <Button variant="danger" type="reset" onClick={() => setFormData({ id: null, uom_name: '', description: '', active_status: '1' })}>Reset</Button>
                </>
              ) : (
                <>
               <Button variant="warning" type="submit" disabled={loading}>
                {loading ? 'Updating...' : 'Update'}
              </Button>
                  <Button variant="danger" onClick={() => setShowModal(false)}>Cancel</Button>
                </>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Password Confirmation Modal */}
      <Modal
        show={showPasswordModal}
        onHide={() => {
          setShowPasswordModal(false);
          setIsEditMode(true);
          setShowModal(true);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Enter Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>To change status, enter your password</Form.Label>
            <Form.Control
              type="password"
              value={passwordInput}
              onChange={(e) => setPasswordInput(e.target.value)}
              placeholder="Enter password"
            />
            {statusMessage && <div className="text-danger mt-2">{statusMessage}</div>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={confirmStatusChange}>Confirm</Button>
          <Button variant="danger" onClick={() => {
            setShowPasswordModal(false);
            setIsEditMode(true);
            setShowModal(true);
          }}>Cancel</Button>
        </Modal.Footer>
      </Modal>

      {/* Toast Notifications */}
    

      <style>{`
        .custom-switch-green .form-check-input:checked {
          background-color: #28a745 !important;
          border-color: #28a745 !important;
        }
        .custom-switch-red .form-check-input {
          background-color: #dc3545 !important;
          border-color: #dc3545 !important;
        }
      `}</style>
    </Card>
      <ToastContainer />
      </>
  );
};

export default UomMaster;
